module.exports = __webpack_public_path__ + "img/rowing.3ac79f25.svg";